import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { aiStudioService } from 'shared/src/api';
import { useMyInfo } from 'shared/src/queries';

export const useRepresentativeImagesRedirectPath = () => {
  const goodsSno = useGoodsSno();
  const { data: me } = useMyInfo();

  return useQuery({
    enabled: !me.is_anonymous,
    queryKey: queryKey.goodsRepresentativeImagesRedirectPath(goodsSno),
    queryFn: () =>
      aiStudioService.getRepresentativeImageRedirectPath({
        goods_sno: goodsSno,
      }),
  });
};
